import { gql, DocumentNode } from '@apollo/client';

const COLLECTION_FIELDS = `
  backgroundImg
  description
  id
  items {
    ... on CollectionLinkItem {
      collectionId
      name
      slug
      type
      vimeoThumbnail
      description
    }
    ... on ExtrasCollectionItem {
      downloadUrl
      name
      slug
      vimeoThumbnail
      description
    }
    ... on WorkoutCollectionItem {
      duration
      name
      slug
      videoId
      vimeoThumbnail
      description
      workout {
        workoutName
        categories
        equipment
        imageWide
        tiers
        durationInSeconds
      }
    }
  }
  itemsCount
  itemsTotal
  name
  shortDescription
  slug
  type
`;

// Query a collection by a collection id
const GET_COLLECTION = gql`
  query GetCollection($id: Int!, $page: Int, $perPage: Int) {
    collection(id: $id, page: $page, perPage: $perPage) {
      ${COLLECTION_FIELDS}
    }
  }
`;

const GET_COLLECTION_V2 = gql`
  query GetCollectionV2($id: Int!, $page: Int, $perPage: Int) {
    collectionV2(id: $id, page: $page, perPage: $perPage) {
      ${COLLECTION_FIELDS}
    }
  }
`;

/**
 * Returns the appropriate query and response field name based on the feature flag.
 *
 * Usage:
 *   const { rtCollectionV2 } = useFlags();
 *   const { query, fieldName } = getCollectionQuery(rtCollectionV2);
 *   const { data } = await client.query({ query, variables: { id, page, perPage } });
 *   const collection = data[fieldName];
 */
export function getCollectionQuery(useV2: boolean): {
  query: DocumentNode;
  fieldName: 'collection' | 'collectionV2';
} {
  return useV2
    ? { query: GET_COLLECTION_V2, fieldName: 'collectionV2' }
    : { query: GET_COLLECTION, fieldName: 'collection' };
}

export { GET_COLLECTION_V2 };
export default GET_COLLECTION;
